module.exports = __webpack_public_path__ + "static/media/delete-salon-img.78e79aa7.png";